import { Alert, Button, Heading, Spinner, Text } from '@components'
import { BookOpenCheck, RefreshCcw, TriangleAlert } from 'lucide-solid'
import { Match, Switch } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { useCreate } from '../state'

export default function Success() {
	const { createError, createSuccess, createSetupResource, refetchCreate, isEditing } =
		useService(useCreate)()

	return (
		<Grid
			mt={6}
			justifyItems="center"
		>
			<Switch>
				<Match when={createError()}>
					<Alert.Root>
						<Alert.Icon asChild={(iconProps) => <TriangleAlert {...iconProps()} />} />
						<Alert.Content>
							<Alert.Title>
								{isEditing() ? 'Error updating Setup' : 'Error creating Setup'}
							</Alert.Title>
							<Alert.Description>{createError()}</Alert.Description>
						</Alert.Content>
					</Alert.Root>
					<Text mt={4}>
						Please update the specified fields and resubmit the form, or try again
					</Text>
					<Button onClick={refetchCreate}>
						<RefreshCcw />
						Try Again
					</Button>
				</Match>
				<Match when={createSetupResource.loading}>
					<Spinner />
					<Text>{isEditing() ? 'Editing New Setup' : 'Creating New Setup'}</Text>
				</Match>
				<Match when={createSuccess()}>
					<BookOpenCheck
						size={60}
						class={css({
							color: 'tscGreen.10',
						})}
					/>
					<Heading size="lg">Success!</Heading>
					<Text>
						{isEditing()
							? 'This setup has been edited'
							: 'This setup will be created as inactive until a trade leader has approved it'}
					</Text>
				</Match>
			</Switch>
		</Grid>
	)
}
